import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import TagManager from "react-gtm-module";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "react-quill/dist/quill.snow.css";
import "react-quill/dist/quill.bubble.css";
import "./sass/custom.scss";
import { store } from "./store";

const tagManagerArgs = {
  gtmId: process.env.REACT_APP_GTM_ID || "",
  event: "appLoad",
};

// TagManager.initialize(tagManagerArgs);

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
